var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full flex gap-2"},[_c('feather-icon',{attrs:{"icon":"CopyIcon","svgClasses":"h-5 w-5 mr-4 hover:text-primary cursor-pointer"},on:{"click":_vm.copy}}),_c('span',[_vm._v(_vm._s(_vm.params.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }